module.exports = __webpack_public_path__ + "assets/img/fb_msg.25e5dfe9.png";